import { Badge } from "@/components/base/badges/badges";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";

type BadgeColor = "warning" | "success" | "gray" | "error" | "brand";

type Props = {
  status: string;
};

const STATUS_LABELS: Record<string, string> = {
  normal: "On Going",
  terminating: "Expiring",
  terminated: "Completed",
  added: "Added",
  "not added": "Not Added",
  draft: "Unbox Draft",
};

const STATUS_COLORS: Record<string, BadgeColor> = {
  normal: "success",
  terminating: "warning",
  terminated: "gray",
  added: "success",
  "not added": "warning",
  draft: "brand",
};

const getStatusLabel = (status: string): string => {
  const normalizedStatus = status.toLowerCase();
  return STATUS_LABELS[normalizedStatus] ?? status;
};

const getStatusColor = (status: string): BadgeColor => {
  const normalizedStatus = status.toLowerCase();
  return STATUS_COLORS[normalizedStatus] ?? "gray";
};

const isDraft = (status: string): boolean => status.toLowerCase() === "draft";

export const CollaborationStatusBadge = ({ status }: Props) => {
  const badge = (
    <Badge color={getStatusColor(status)} size="sm">
      {getStatusLabel(status)}
    </Badge>
  );

  if (isDraft(status)) {
    return (
      <Tooltip
        title="Unbox Draft"
        description="This is an Unbox draft. It won't appear on TikTok until a creator is added to this collaboration."
        arrow
        placement="top"
      >
        <TooltipTrigger className="inline">{badge}</TooltipTrigger>
      </Tooltip>
    );
  }

  return badge;
};
